import type { CatalogEntry } from "@core/types";
import { PlaceCheckboxList } from "./PlaceCheckboxList";
import { RFieldGroup } from "./RFieldGroup";

interface PlaceEntries {
  data: CatalogEntry[] | undefined;
  isLoading: boolean;
}

// PA-025-E (agent-logs/runs/2026-09-09-spec-211-portal/evidence/
// human-resolution-pa-025-e-duplication.json): la rejilla de dos columnas
// "Comercios aliados" / "Talleres" (ANNEX-011 §2.1, PA-023-C) era el mismo
// marcado palabra por palabra en BenefitsScreen.tsx y RewardsScreen.tsx.
// Extracción sin cambio de comportamiento ni de valores visuales.
export function PlacesFieldGroup({
  merchants,
  merchantIds,
  onToggleMerchant,
  workshops,
  workshopIds,
  onToggleWorkshop,
}: {
  merchants: PlaceEntries;
  merchantIds: readonly string[];
  onToggleMerchant: (id: string) => void;
  workshops: PlaceEntries;
  workshopIds: readonly string[];
  onToggleWorkshop: (id: string) => void;
}) {
  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 1fr",
        gap: "0 16px",
      }}
    >
      <RFieldGroup
        label="Comercios aliados"
        hint="Dónde puede consumirse fuera de Teojama."
      >
        <PlaceCheckboxList
          legend="Comercios aliados"
          entries={merchants.data}
          selected={merchantIds}
          onToggle={onToggleMerchant}
          isLoading={merchants.isLoading}
        />
      </RFieldGroup>
      <RFieldGroup
        label="Talleres"
        hint="Dónde puede consumirse en un taller de Teojama."
      >
        <PlaceCheckboxList
          legend="Talleres"
          entries={workshops.data}
          selected={workshopIds}
          onToggle={onToggleWorkshop}
          isLoading={workshops.isLoading}
        />
      </RFieldGroup>
    </div>
  );
}
